import { useLocation } from 'quartz-routing/react-router';
import { useCallback, useMemo } from 'react';
import useIsNearViewport from 'academy-common-lib/hooks/useIsNearViewport';
import { Metrics } from '../../utils/Metrics';
import { getListingUrl } from './routing/RoutingUtils';
import resizeImage from 'FileManagerLib/utils/resize';
import { getPlaylistUrl } from '../playlist/playlistRouting';
const isLessonCard = item => item.type === 'LESSON';
export const useLearningContentCardTo = ({
  item,
  overviewType,
  playlistId,
  showOverview
}) => {
  var _item$lessonType;
  const {
    id,
    type,
    language,
    progress
  } = item;
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  const isStarted = type !== 'LIVE_EVENT' && progress && progress.status !== 'NOT_STARTED';
  const isExerciseLesson = isLessonCard(item) && !!((_item$lessonType = item.lessonType) !== null && _item$lessonType !== void 0 && _item$lessonType.includes('EXERCISE'));
  const to = useMemo(() => {
    if (type === 'PLAYLIST' || type === 'LEARNING_PATH') {
      return getPlaylistUrl(id);
    }
    return getListingUrl({
      type: type,
      isStarted: showOverview !== undefined ? !showOverview : isExerciseLesson || !!isStarted,
      id,
      language: language,
      currentPathname: pathname,
      currentSearch: search,
      appearsIn: overviewType,
      playlistId
    });
  }, [id, isExerciseLesson, isStarted, language, overviewType, pathname, playlistId, search, showOverview, type]);
  return Object.assign({}, to, {
    state: {
      backLocation: location
    }
  });
};
export const useMeasureThumbnailLoadTime = imageSrc => {
  const handleThumbnailLoad = useCallback(() => {
    if (!imageSrc) return;
    const entries = performance.getEntriesByName(imageSrc, 'resource');
    const entry = entries[entries.length - 1];
    if (entry) {
      Metrics.timer('thumbnail-load-time').update(entry.duration);
    }
  }, [imageSrc]);
  return handleThumbnailLoad;
};
export const useThumbnailUrl = ({
  thumbnailUrl,
  size
}) => {
  const {
    ref: cardRef,
    isNearViewport
  } = useIsNearViewport();
  const resizedUrl = useMemo(() => thumbnailUrl ? resizeImage(thumbnailUrl, size) || thumbnailUrl : undefined, [thumbnailUrl, size]);
  const imageSrc = isNearViewport ? resizedUrl : undefined;
  const onThumbnailLoad = useMeasureThumbnailLoadTime(imageSrc);
  return {
    cardRef,
    imageSrc,
    onThumbnailLoad
  };
};